// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.
//
// Migrated from Webpack's `require.context` to Vite's `import.meta.glob`.
// The identifier scheme matches Stimulus' `definitionsFromContext`: a
// controller at `foo/bar_controller.js` is registered as `foo--bar`.
import { Application } from 'stimulus';

const application = Application.start();

const controllerModules = import.meta.glob('./**/*_controller.js', {
  eager: true,
});

for (const path in controllerModules) {
  const identifier = path
    .replace(/^\.\//, '')
    .replace(/_controller\.js$/, '')
    .replaceAll('/', '--');
  application.register(identifier, controllerModules[path].default);
}
